export enum ContentFlavor {
    TEXTUAL,
    IMAGE,
    DIAGRAM,
    FORM,
    GOOGLEDRIVE,
    UNKNOWN,
}

export function get_mimetype_flavor(mimetype: string = ""): ContentFlavor {
    switch (mimetype) {
        case "application/json":
            return ContentFlavor.TEXTUAL;
        case "application/jsonschema":
        case "application/schema+json":
            return ContentFlavor.FORM;
        case "application/dmn+xml":
        case "application/bpmn+xml":
            return ContentFlavor.DIAGRAM;
    }

    // Check flavor based on mimetype prefix
    if (mimetype.startsWith("text")) {
        return ContentFlavor.TEXTUAL;
    } else if (mimetype.startsWith("image")) {
        return ContentFlavor.IMAGE;
    } else if (mimetype.startsWith("application/vnd.google-apps")) {
        return ContentFlavor.GOOGLEDRIVE;
    } else {
        return ContentFlavor.UNKNOWN;
    }
}
